import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/IFilterTipoVisitaModel';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterTipoVisitaModel } from 'src/app/models/tipo-visita/FilterTipoVisitaModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';
import { ConfiguracionTipoVisitaDefaultDialogComponent } from '../configuracion-tipo-visita-default-dialog/configuracion-tipo-visita-default-dialog.component';

@Component({
  selector: 'app-configuracion-tipo-visita-listar',
  templateUrl: './configuracion-tipo-visita-listar.component.html',
  styleUrls: ['./configuracion-tipo-visita-listar.component.css']
})
export class ConfiguracionTipoVisitaListarComponent implements OnInit {
  model!: SearchResultModel<ITipoVisitaModel[]>;
  filter: IFilterTipoVisitaModel = new FilterTipoVisitaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'defaultcontratista',
    'estado',
    'acciones'
  ];

  @ViewChild('paginator') paginator!: MatPaginator;
  
  constructor(
    private tipoVisitaService: TipoVisitaService,
    private serviceParametros: ParametroService,
    public dialog: MatDialog,
  ) { 
    this.model = new SearchResultModel<ITipoVisitaModel[]>(false, new Array<ITipoVisitaModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    const filter: IFilterTipoVisitaModel = new FilterTipoVisitaModel();

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_TIPO_VISITA).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.tipoVisitaService.getListPaged(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.tipoVisitaService
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  setdefault(): void{
    const dialogRef = this.dialog.open(ConfiguracionTipoVisitaDefaultDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: this.model 
    });  
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.tipoVisitaService
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }
}
